import { useEffect, useState } from "react";

import {
    API_IS_BEING_CANCELLED,
    ENDPOINTS,
    TASK_TYPES,
    useApi,
    useIsMounted
} from "../../../../../../../shared";
import { sortVehicles } from "../functions";
import {
    Make,
    Model,
    Vehicles
} from "../SecondSelectContent/CanVehicles/types";
import { SelectedTask } from "../types";

const useCanVehicles = (selectedTask: SelectedTask) => {
    const { getData, handleResponse, cancelSource, isCanceled } = useApi();
    const isMounted = useIsMounted();

    const [isLoading, setIsLoading] = useState(false);
    const [vehicles, setVehicles] = useState<Vehicles>(null);
    const [makes, setMakes] = useState<string[]>([]);
    const [make, setMake] = useState<Make>(null);
    const [model, setModel] = useState<Model>(null);

    useEffect(() => {
        setMake(null);
        setModel(null);

        const getVehicles = async () => {
            try {
                setIsLoading(true);

                const { data } = await getData(ENDPOINTS.Vehicles);

                if (isMounted) {
                    sortVehicles(data, setVehicles, setMakes);
                }
            } catch (error) {
                if (isMounted && !isCanceled(error)) {
                    handleResponse(error);
                }
            }

            setIsLoading(false);
        };

        const isUploadCanOemFileTask =
            selectedTask?.type === TASK_TYPES.TxCanConfiguration;

        isUploadCanOemFileTask && getVehicles();

        return () => {
            cancelSource.cancel(API_IS_BEING_CANCELLED);
        };

        // eslint-disable-next-line
    }, [selectedTask?.type]);

    const changeMake = (makeName: string) => {
        setMake(makeName);
        setModel(null);
    };

    const changeModel = (vehicleInfo: Model) => setModel(vehicleInfo);

    return {
        additionalData: {
            isVehiclesLoading: isLoading,
            vehicles,
            makes,
            make,
            model
        },
        changeMake,
        changeModel
    };
};

export { useCanVehicles };
